/**
 * Created by SmilingXinyi <smilingxinyi@gmail.com> on 2020/6/2
 */

import {phoneAgentPrefix, PrefixType, BrowserAgent, BrowserType} from './constants'

function parse(str: string) {
    if (typeof str !== 'string') {
      throw new TypeError('argument str must be a string');
    }
  
    var obj: Record<string, string> = {}
  
    var index = 0
    while (index < str.length) {
      var eqIdx = str.indexOf('=', index)
  
      // no more cookie pairs
      if (eqIdx === -1) {
        break
      }
  
      var endIdx = str.indexOf(';', index)
  
      if (endIdx === -1) {
        endIdx = str.length
      } else if (endIdx < eqIdx) {
        // backtrack on prior semicolon
        index = str.lastIndexOf(';', eqIdx - 1) + 1
        continue
      }
  
      var key = str.slice(index, eqIdx).trim()
  
      // only assign once
      if (undefined === obj[key]) {
        var val = str.slice(eqIdx + 1, endIdx).trim()
  
        // quoted values
        if (val.charCodeAt(0) === 0x22) {
          val = val.slice(1, -1)
        }
  
        obj[key] = val;
      }
  
      index = endIdx + 1
    }
  
    return obj;
  }
/**
 * Cookie parsing
 * @param cookieStr
 */
export function parseCookie(cookieStr: string = ''): any {
    const cookies = cookieStr.toLowerCase();
    return parse(cookies);
}

/**
 * User-Agent phone parsing
 * @param userPhoneAgent
 * @param userAgent
 */
export function parsePhone(userPhoneAgent: string, userAgent: string): string {
    // iphone
    if (userAgent.includes('iphone')) {
        return 'iphone';
    }
    // 三星
    if (userPhoneAgent.startsWith('sm-')) {
        return 'sanxing';
    }
    // 华为及华为的一些联名款
    if (userAgent.includes('huawei')
        || userAgent.includes('hmscore')
        || userAgent.includes('harmonyos')
        || userAgent.includes('nova')
        || userAgent.includes('tianyi')
        || userPhoneAgent.includes('mnt-bd00')
        || userPhoneAgent.includes('fio-')
        || userPhoneAgent.includes('sp210')
        || userPhoneAgent.includes('sp200')
        || userPhoneAgent.includes('lya-al')
        || userPhoneAgent.includes('ane-')
        || userPhoneAgent.includes('nco-')
        || userPhoneAgent.startsWith('ava-pa00')
    ) {
        return 'huawei';
    }

    if (['pj', 'r7', 'pc', 'ph', 'pa', 'pb', 'pe', 'op', 'pg', 'pd', 'pf', 'oppo'].some(item => userPhoneAgent.startsWith(item))) {
        return 'oppo';
    }

    if (userAgent.includes('honor') || userPhoneAgent.startsWith('nat-tn70')) {
        return 'honor';
    }

    if (['vivo', 'v1', 'v2', 'x70pro'].some(item => userPhoneAgent.startsWith(item))) {
        return 'vivo';
    }

    if (userPhoneAgent.startsWith('xt2') || userAgent.includes('moto')) {
        return 'motorola';
    }

    if (userPhoneAgent.startsWith('sov') || userPhoneAgent.startsWith('xq-') || userPhoneAgent.startsWith('j9110')) {
        return 'sony';
    }

    if (userAgent.includes('wiko') || userPhoneAgent.startsWith('lft-an00')) {
        return 'wiko';
    }

    if (['ne22', 'le', 'in', 'mt', 'kb20', 'gm', 'oneplus', 'nb20', 'hd19'].some(item => userPhoneAgent.startsWith(item))) {
        if (!userPhoneAgent.startsWith('intel')) {
            return 'oneplus';
        }
    }

    if (userAgent.includes('ipad')) {
        return 'ipad';
    }

    if (userPhoneAgent.startsWith('vp') || userPhoneAgent.startsWith('cmcc')) {
        return 'liantong';
    }

    if (['meizu', 'pro', 'm3', 'mx6', '16t', 'm15', 'm6'].some(item => userPhoneAgent.startsWith(item))) {
        return 'meizu';
    }

    if (['os105', 'dt', 'od105'].some(item => userPhoneAgent.startsWith(item))) {
        return 'chuizi';
    }

    if (['nx6', 'nx5', 'nx7'].some(item => userPhoneAgent.startsWith(item))) {
        return 'nubiya';
    }

    if (userPhoneAgent.split(' ')[1] && userPhoneAgent.split(' ')[1].endsWith('-a01')) {
        return '360';
    }

    let result;
    Object.keys(phoneAgentPrefix).some((prefix) => {
        if (userPhoneAgent.startsWith(prefix)) {
            result = phoneAgentPrefix[prefix as PrefixType];
            return true;
        }
        return false;
    });

    if (result) {
        return result;
    }

    if (['mi', 'm1', 'm2', 'dlt-a0', 'redmi', 'shark', 'skw-'].some(item => userPhoneAgent.startsWith(item))) {
        return 'xiaomi';
    }

    if (/^2[0-9]/.test(userPhoneAgent)) {
        return 'xiaomi';
    }

    if (userAgent.includes('mac')) {
        return 'mac';
    }

    if (
        userAgent.indexOf('windows') >= 0 ||
        userAgent.indexOf('win16') >= 0 ||
        userAgent.indexOf('win32') >= 0 ||
        userAgent.indexOf('win64') >= 0 ||
        userAgent.indexOf('win95') >= 0 ||
        userAgent.indexOf('win98') >= 0 ||
        userAgent.indexOf('winnt') >= 0 ||
        userAgent.indexOf('wow64') >= 0
    ) {
        return 'windows';
    }

    return 'unkonwn';
}

/**
 * User-Agent os version parsing
 * @param osAgent
 * @param osStr
 */
function parseOsVersion(osAgent: string, osStr: string): string {
    const osArr = osAgent.split(' ');
    const osVersion = osArr.find(item => /.*\d.*/.test(item));
    if (osVersion) {
        return osStr + ' ' + osVersion;
    }
    return osStr;
}

/**
 * User-Agent os parsing
 * @param userOsAgent
 * @param userAgentStr
 */
export function parseOs(userOsAgent: string | undefined, userAgentStr: string): string {
    if (
        userAgentStr.indexOf('iphone') >= 0 ||
        userAgentStr.indexOf('ipad') >= 0 ||
        userAgentStr.indexOf('ipod') >= 0 ||
        userAgentStr.indexOf('crios') >= 0 ||
        userAgentStr.indexOf('fxios') >= 0
    ) {
        if (userOsAgent) {
            return parseOsVersion(userOsAgent, 'iOS');
        } else {
            return 'iOS';
        }
    }
    if (
        userAgentStr.indexOf('mac') >= 0 ||
        userAgentStr.indexOf('macintosh') >= 0 ||
        userAgentStr.indexOf('mac_powerpc)') >= 0
    ) {
        const osAgentArr = userAgentStr.split(';');
        if (osAgentArr[1]) {
            return parseOsVersion(osAgentArr[1].split(')')[0], 'Mac');
        }
        return 'Mac';
    }

    if (userAgentStr.includes('harmonyos')) {
        const agentArr = userAgentStr.split(';');
        const osAgentStr = agentArr.find(item => item.includes('hmscore'));
        if (osAgentStr) {
            return parseOsVersion(osAgentStr.split(')')[0], 'HarmonyOS');
        }
        return 'HarmonyOS';
    }

    if (userAgentStr.includes('android')) {
        if (userOsAgent) {
            return userOsAgent;
        }
        const userAgentArr = userAgentStr.split(';');
        const osAgentStr = userAgentArr[1] ? userAgentArr[1].trim() : userAgentStr;
        return osAgentStr ? osAgentStr : 'Android';
    }

    if (
        userAgentStr.includes('linux') ||
        userAgentStr.includes('cros')
    ) {
        return 'Linux';
    }

    if (userAgentStr.includes('x11')) {
        if (userAgentStr.includes('netbsd')) {
            return 'NetBSD';
        } else if (userAgentStr.includes('freebsd')) {
            return 'FreeBSD';
        } else if (userAgentStr.includes('openbsd')) {
            return 'OpenBSD';
        } else {
            return 'Linux';
        }
    }
    if (userAgentStr.indexOf('windows phone') >= 0) {
        return 'Windows Phone';
    } else if (
        userAgentStr.indexOf('windows') >= 0 ||
        userAgentStr.indexOf('win16') >= 0 ||
        userAgentStr.indexOf('win32') >= 0 ||
        userAgentStr.indexOf('win64') >= 0 ||
        userAgentStr.indexOf('win95') >= 0 ||
        userAgentStr.indexOf('win98') >= 0 ||
        userAgentStr.indexOf('winnt') >= 0 ||
        userAgentStr.indexOf('wow64') >= 0
    ) {
        const agentArr = userAgentStr.split('(');
        if (agentArr[1]) {
            const osString = agentArr[1].split(';')[0];
            if (osString.includes(')')) {
                return osString.split(')')[0];
            } else {
                return osString;
            }
        }
        return 'Windows';
    } else {
        return 'Other';
    }
}
/**
 * User-Agent browser parsing
 * @param userAgent 
 * @returns 
 */
export function parseBrowser(userAgent: string): string {
    if (userAgent.includes('honorbrowser')) {
        return 'honorbrowser';
    }

    if (userAgent.includes('baidu')) {
        if (userAgent.includes('swan-')) {
            if (userAgent.includes('swan-bmsxwallet')) {
                return 'baidu-swan';
            } else {
                return 'asset-app';
            }
        } else if (!userAgent.includes('baiduspider')){
            return 'baidu-h5';
        }
    }

    if (userAgent.includes('huaweibrowser')) {
        return 'huaweibrowser';
    }
    // @ts-ignore
    if ((window && window.__wxjs_environment === 'miniprogram') || userAgent.includes('miniprogram')) {
        return 'weixin-mini';
    }

    let result;
    Object.keys(BrowserAgent).some(key => {
        if (userAgent.includes(key)) {
            result = BrowserAgent[key as BrowserType];
            return true;
        }
        return false;
    });

    if (result) {
        return result;
    }

    if (userAgent.includes('micromessenger')) {
        return 'weixin';
    }

    if (['edge/', 'iemobile/', 'edga/', 'edg/'].some(item => userAgent.includes(item))) {
        return 'edge';
    }
    // 手机端很多浏览器ua都带safri，chrome等关键字，所以只在pc端做判断
    if (!userAgent.includes('mobile')) {
        if (userAgent.indexOf('opera mini') >= 0) {
            return 'opera mini';
        } else if (userAgent.indexOf('firefox/') >= 0) {
            return 'Firefox';
        } else if (
            userAgent.indexOf('opera/') >= 0 ||
            userAgent.indexOf(' opr/') >= 0
        ) {
            return 'Opera';
        } else if (userAgent.indexOf('chrome/') >= 0) {
            return 'Chrome';
        } else if (userAgent.indexOf('safari/') >= 0) {
            return 'Safari';
        } else if (userAgent.indexOf('trident/') >= 0) {
            return 'Internet Explorer';
        }
    }

    const userAgentArr = userAgent.split(' ');

    return userAgentArr[userAgentArr.length - 1];
}
/**
 * 解析出浏览器内核及其版本
 * @param userAgent 
 * @returns 
 */
export function parseBrowserCore(userAgent: string): {core: string, version: string} {
    try {
        const userAgentArr = userAgent.split(')');
        console.log(userAgentArr);
        const browserCoreArr = userAgentArr[1].split(' ')[1].split('/');
        return {core: browserCoreArr[0], version: browserCoreArr[1]};
    } catch (e) {
        return {core: '', version: ''}
    } 
}

/**
 * User-Agent parsing
 * @param userAgent
 */
export function parseUserAgent(userAgent: string): any {
    try {
        const userAgentStr = userAgent.toLowerCase();

        let phoneAgent;   // 没解析过的手机版本号
        let phone;         // 解析后的手机版本号
        let osAgent;       // 没解析过的操作系统及其版本号
        let osAndVersion;        // 解析后的操作系统及其版本号
        let browser;
        let browserCoreAndVersion = parseBrowserCore(userAgentStr);

        const device = userAgentStr.includes('mobile') ? 'mobile' : 'other';

        const phoneAndOsAgentArr = userAgentStr.split(';');
        phoneAgent = phoneAndOsAgentArr[2] ? phoneAndOsAgentArr[2].trim()
            : phoneAndOsAgentArr[1] ? phoneAndOsAgentArr[1].trim() : userAgentStr;
        phone = parsePhone(phoneAgent, userAgentStr);
        osAgent = phoneAndOsAgentArr[1] ? phoneAndOsAgentArr[1].trim() : userAgentStr;

        if (userAgentStr.includes('mobile')) {
            if (!phone) {
                phone = phoneAgent;
            }
        }

        osAndVersion = parseOs(osAgent, userAgentStr);
        browser = parseBrowser(userAgentStr);

        const osArr = osAndVersion.split(' ');
        let os = osArr.slice(0, -1).join(' ');
        let version = osArr[osArr.length - 1] || '';
        if (!(osArr.length > 1 && osArr[osArr.length - 1].match(/\d+/))) {
            os = osAndVersion;
            version = '';
        }

        let mobileDevice = false;
        if (window) {
            mobileDevice =
                'ontouchstart' in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0;
        }

        return {
            d: device,
            db: phone,
            dm: '',
            bb: browser,
            bv: '',
            bc: browserCoreAndVersion.core,
            bcv: browserCoreAndVersion.version,
            os,
            osv: version,
            md: mobileDevice,
        };
    } catch (e) {
        console.warn(e);
        return {};
    }
}

/**
 * Performance parsing
 * @param perf
 */
export function parsePerformance(perf: any): any {
    try {
        const { responseStart } = perf;
        const { responseEnd } = perf;

        return {
            ft: Math.floor(responseEnd - perf.fetchStart),
            wt: Math.floor(perf.workerStart > 0 ? responseEnd - perf.workerStart : 0),
            tt: Math.floor(responseEnd - perf.requestStart),
            dt: Math.floor(responseEnd - responseStart),
            ttfb: Math.floor(responseStart - perf.requestStart),
            hs: Math.floor(Math.abs(perf.transferSize - perf.encodedBodySize || 0)),
            dns: Math.floor(perf.domainLookupEnd - perf.domainLookupStart),
            tcp: Math.floor(perf.connectEnd - perf.connectStart),
            rt: Math.floor(perf.redirectEnd - perf.redirectStart),
            dclt: Math.floor(perf.domInteractive - responseEnd),
            tti: Math.floor(perf.domInteractive - perf.fetchStart)
        };
    } catch (e) {
        return {};
    }
}

type MatchItem = {
    key: string;
    index: number;
};

type MathResultItem = {
    [key: string]: string;
};

/**
 * URL Pathname Parsing
 * @param schema
 * @param pathname
 */
export function parsePathname(schema: string, pathname: string): any {
    if (!schema.startsWith('/', 0)) {
        throw 'schema dose not start with "/"';
    }

    if (!pathname.startsWith('/', 0)) {
        throw 'pathname dose not start with "/"';
    }

    const pathArr = pathname.split('/').slice(1);
    const schemaArr = schema.split('/').slice(1);

    const matchList = schemaArr.reduce((accumulator, current, index) => {
        if (current.startsWith(':', 0)) {
            accumulator.push({
                key: current.slice(1),
                index,
            });
        }
        return accumulator;
    }, [] as Array<MatchItem>);

    // @ts-ignore
    const params = matchList.reduce((accumulator, current) => {
        accumulator[current.key] = pathArr[current.index];
        return accumulator;
    }, {} as MathResultItem);

    return params;
}

export function parseQueryString(queryString: string) {
    try {
        const queryParams: Record<string, any> = {};
        const urlParams = new URLSearchParams(queryString);
        urlParams.forEach((value, key) => {
            queryParams[key] = value;
        });
        return queryParams;
    } catch(e) {
        console.warn(e);
        return {};
    }
}

export function qsStringify(obj: Record<string, any>) {
    return Object.keys(obj).map((key) => {
        const value = obj[key];
        if (value === undefined || value === null) {
            return '';
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }).join('&');
}

export function parseReferrer(referrer: string) {
    if (!referrer) {
        return {referrer, referrerPath: referrer};
    }
    // 删除一个url中params中的keyword
    try {
        const urlParts = referrer.split('?');
        if (urlParts.length === 1) {
            // URL中没有查询参数，直接返回原始URL
            return {referrer, referrerPath: referrer};
        }

        let queryParams = urlParts[1];
        let params = queryParams.split('&');

        const filterParams = ['keyword', 'lid', 'orderId', '_'];
        // 过滤掉包含指定keyword的参数
        params = params.filter(param => {
            return filterParams.every(keyword => !param.startsWith(`${keyword}=`));
        });

        if (!params.length) {
            return {referrer: urlParts[0], referrerPath: urlParts[0]};
        }

        // 重新拼接查询参数和URL
        return {referrer: `${urlParts[0]}?${params.join('&')}`, referrerPath: urlParts[0]};
    } catch (e) {
        console.warn(e);
        return {referrer, referrerPath: referrer};
    }
}

export function parsePath(location: any) {
    if (location && location.origin) {
        let path = location.origin + location.pathname;
        if (location.hash) {
            let hashUrl = location.hash.split('?')[0];
            if (path.endsWith('/')) {
                path = path + hashUrl;
            } else {
                path = path + '/' + hashUrl;
            }
        }
        return path;
    }
    return '';
}
// 获取_frm参数
export function parseFrom(location: any, key: string = '_frm') {
    const {search, href, hash} = location;
    // 处理hash参数
    let query = search || '';
    if (!query && hash && hash.includes('?')) {
        query = hash.split('?')[1];
    }
    const queryObj = parseQueryString(query) || {};
    // 从query 和hash中获取_frm参数
    if (queryObj[key]) {
        return queryObj[key]
    }
    // 从href中获取_frm参数
    const hrefList = href.split(key + '=');
    if (hrefList.length > 1) {
        return hrefList[1].split('&')[0];
    }
    return '';
}